export enum ContactDetailType {
  PhoneContact,
  EInvoice,
  EMail,
  OperatorId,
  OperatorName,
  Homepage
}